import { useState, useEffect, useRef } from 'react';

import { useAppSelector } from '@store/index';
import { getMeetingDisplayMode } from '@store/studio/studio.slice';
import { MeetingDisplayMode } from 'src/type/meeting';

const useImmersiveMode = () => {
  const meetingDisplayMode = useAppSelector(getMeetingDisplayMode);

  const [mouseIsStatic, setMouseIsStatic] = useState(false);

  const mouseWatcherTimer = useRef<number>(0);

  const MouseTimeoutWatcher = () => {
    window.clearTimeout(mouseWatcherTimer.current);
    mouseWatcherTimer.current = 0;

    setMouseIsStatic(false);

    mouseWatcherTimer.current = window.setTimeout(() => {
      setMouseIsStatic(true);
    }, 5000);
  };

  useEffect(() => {
    MouseTimeoutWatcher();
    window.addEventListener('mousemove', MouseTimeoutWatcher);
    window.addEventListener('mousedown', MouseTimeoutWatcher);

    return () => {
      window.removeEventListener('mousemove', MouseTimeoutWatcher);
      window.removeEventListener('mousedown', MouseTimeoutWatcher);
    };
  }, []);

  return mouseIsStatic && meetingDisplayMode !== MeetingDisplayMode.PureAudio;
};

export default useImmersiveMode;
